import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MemberResponseInterface } from '@careapp/angular-sdk';

import { FormCoreComponent } from '../form-core';

@Component({
  selector: 'staff-form',
  templateUrl: './staff-form.component.html'
})
export class StaffFormComponent extends FormCoreComponent<MemberResponseInterface> {
  role: FormGroup;

  @Input()
  set disabled(val: boolean) {
    this._disabled = val;
    if (this._disabled) {
      this.role.disable();
    } else {
      this.role.enable();
    }
  }

  get disabled() {
    return this._disabled;
  }

  @Input()
  set staff(value: MemberResponseInterface) {
    if (value) {
      this.form.patchValue(value, { emitEvent: true, onlySelf: true });
      this.form.disable();
      let permission;
      try {
        permission = value.permissions.pop();
      } catch (ex) {
        // do nothing
      }
      if (permission) {
        this.role.patchValue(permission, { emitEvent: true, onlySelf: true });
      }
    } else {
      this.form.patchValue({}, { emitEvent: true, onlySelf: true });
      this.form.disable();
      this.role.patchValue({}, { emitEvent: true, onlySelf: true });
    }
  }

  constructor() {
    super();
    this.role = new FormGroup({
      enabled: new FormControl('', Validators.required),
      role: new FormControl('', Validators.required)
    });

    this.form = new FormGroup({
      profileImage: new FormControl('', Validators.required),
      firstName: new FormControl('', Validators.required),
      lastName: new FormControl('', Validators.required)
    });
    // Can only modify role
    this.form.disable();
  }

  onSubmit() {
    this.submitted.emit(this.role.value);
  }
}
